import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

const GoodAfternoonIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 50 44" {...props}>
      <path
        d="M40.623 25.6661C41.9252 23.8028 42.689 21.5356 42.689 19.0899C42.689 12.7424 37.5433 7.59668 31.1958 7.59668C25.9673 7.59668 21.5543 11.088 20.1608 15.8664V28.9693H40.9811L40.623 25.6661Z"
        fill="#FFD900"
      />
      <path
        d="M42.689 19.0899C42.689 12.7424 37.5433 7.59668 31.1957 7.59668C30.8143 7.59668 30.4377 7.61749 30.0658 7.65377C35.8735 8.23057 40.4094 13.1304 40.4094 19.0899C40.4094 21.5355 39.6456 23.8028 38.3434 25.6661L38.7015 28.9693H40.981L40.6229 25.6661C41.9252 23.8028 42.689 21.5355 42.689 19.0899Z"
        fill="#FFBB00"
      />
      <path
        d="M49.2565 19.8333H45.9728C45.5623 19.8333 45.2295 19.5006 45.2295 19.09C45.2295 18.6794 45.5623 18.3467 45.9728 18.3467H49.2565C49.667 18.3467 49.9998 18.6794 49.9998 19.09C49.9998 19.5005 49.667 19.8333 49.2565 19.8333Z"
        fill="#FFD900"
      />
      <path
        d="M41.6454 9.38189C41.4552 9.38189 41.2649 9.30934 41.1198 9.16425C40.8295 8.87396 40.8295 8.4033 41.1198 8.11311L43.4418 5.79101C43.7321 5.50062 44.2028 5.50072 44.493 5.79091C44.7833 6.0812 44.7833 6.55186 44.493 6.84205L42.171 9.16415C42.0259 9.30924 41.8357 9.38189 41.6454 9.38189Z"
        fill="#FFD900"
      />
      <path
        d="M31.1958 5.05259C30.7853 5.05259 30.4525 4.71989 30.4525 4.30928V1.02554C30.4525 0.614932 30.7853 0.282227 31.1958 0.282227C31.6063 0.282227 31.9391 0.614932 31.9391 1.02554V4.30928C31.9391 4.71989 31.6063 5.05259 31.1958 5.05259Z"
        fill="#FFD900"
      />
      <path
        d="M20.7452 9.37981C20.555 9.37981 20.3647 9.30727 20.2197 9.16217L17.8976 6.84017C17.6074 6.54978 17.6074 6.07922 17.8976 5.78893C18.1879 5.49874 18.6586 5.49874 18.9488 5.78893L21.2708 8.11093C21.5611 8.40132 21.5611 8.87188 21.2708 9.16217C21.1257 9.30727 20.9354 9.37981 20.7452 9.37981Z"
        fill="#FFD900"
      />
      <path
        d="M25.5399 6.17779C25.2482 6.17779 24.9714 6.00504 24.8528 5.71872L24.2245 4.20177C24.0674 3.82249 24.2475 3.3877 24.6268 3.23061C25.006 3.07353 25.441 3.25351 25.5979 3.63289L26.2263 5.14984C26.3834 5.52913 26.2033 5.96391 25.824 6.121C25.731 6.15945 25.6346 6.17779 25.5399 6.17779Z"
        fill="#FFA400"
      />
      <path
        d="M17.5404 14.177C17.4457 14.177 17.3492 14.1588 17.2563 14.1202L15.7393 13.4919C15.36 13.3348 15.18 12.9 15.337 12.5207C15.4941 12.1415 15.929 11.961 16.3082 12.1184L17.8252 12.7468C18.2044 12.9039 18.3845 13.3387 18.2274 13.718C18.1089 14.0042 17.8321 14.177 17.5404 14.177Z"
        fill="#FFA400"
      />
      <path
        d="M46.3676 26.1174C46.2727 26.1174 46.1764 26.0992 46.0834 26.0606L44.5665 25.4323C44.1872 25.2752 44.0071 24.8404 44.1642 24.4611C44.3213 24.0819 44.7563 23.9015 45.1354 24.0588L46.6523 24.6872C47.0316 24.8443 47.2117 25.2791 47.0546 25.6583C46.936 25.9446 46.6592 26.1174 46.3676 26.1174Z"
        fill="#FFA400"
      />
      <path
        d="M44.8512 14.1769C44.5595 14.1769 44.2827 14.0041 44.1642 13.7178C44.0071 13.3385 44.1872 12.9037 44.5665 12.7466L46.0834 12.1183C46.4627 11.9612 46.8975 12.1413 47.0546 12.5206C47.2117 12.8999 47.0316 13.3346 46.6523 13.4917L45.1354 14.1201C45.0424 14.1586 44.946 14.1769 44.8512 14.1769Z"
        fill="#FFA400"
      />
      <path
        d="M36.8516 6.17789C36.7568 6.17789 36.6604 6.15965 36.5675 6.1211C36.1882 5.96401 36.0081 5.52922 36.1652 5.14994L36.7935 3.63299C36.9506 3.2538 37.3855 3.07333 37.7647 3.23071C38.144 3.3878 38.324 3.82258 38.167 4.20187L37.5386 5.71882C37.4201 6.00494 37.1433 6.17789 36.8516 6.17789Z"
        fill="#FFA400"
      />
      <path
        d="M40.1128 25.657H33.2241C32.9367 25.657 32.6927 25.4508 32.6396 25.1684C31.6332 19.7996 26.8946 15.7463 21.2199 15.8063C14.9025 15.8732 9.85123 21.0957 9.85123 27.4137V28.3462C9.85123 28.6746 9.58502 28.9408 9.25658 28.9408H7.48116C3.40722 28.9408 0.0303134 32.1994 8.54319e-05 36.2732C-0.0303407 40.3795 3.28918 43.7178 7.38839 43.7178H40.2262C45.2363 43.7178 49.2935 39.6377 49.2563 34.619C49.2194 29.6397 45.0922 25.657 40.1128 25.657Z"
        fill="#CFEBF9"
      />
      <path
        d="M40.113 25.6572H37.8335C42.8129 25.6572 46.94 29.64 46.977 34.6192C47.0142 39.6379 42.957 43.7181 37.9469 43.7181H40.2264C45.2366 43.7181 49.2938 39.638 49.2565 34.6192C49.2196 29.64 45.0924 25.6572 40.113 25.6572Z"
        fill="#B5D7E7"
      />
      <path
        d="M30.3604 25.1684C30.4134 25.4509 30.6574 25.6571 30.9449 25.6571H33.2244C32.9369 25.6571 32.6929 25.4509 32.6399 25.1684C31.6335 19.7996 26.8949 15.7463 21.2202 15.8063C20.8796 15.8099 20.5428 15.8294 20.2101 15.8624C25.3103 16.3669 29.43 20.2053 30.3604 25.1684Z"
        fill="#B5D7E7"
      />
      <path
        d="M14.777 28.9407C15.1876 28.9407 15.5203 28.608 15.5203 28.1974C15.5203 27.7868 15.1876 27.4541 14.777 27.4541H9.8513V28.346C9.8513 28.6744 9.5851 28.9406 9.25665 28.9406H7.48123C7.48054 28.9406 7.47994 28.9407 7.47925 28.9407H14.777Z"
        fill="#B5D7E7"
      />
    </SvgIcon>
  );
};

export default GoodAfternoonIcon;
